module.exports = __webpack_public_path__ + "img/f3-3.709e6890.png";